import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear(event) {
    event.preventDefault()
    try {
      localStorage.clear()
      sessionStorage.clear()
    } catch (_) {}

    window.location.reload()
  }
}
